// Mock data for retro games
export const retroGames = [
  {
    id: 1,
    title: "JUMPMAN JUNIOR",
    system: "ColecoVision",
    genre: "Platformer",
    vibe: "Hidden Gem",
    year: 1984,
    image: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=400&h=500&fit=crop",
    description: "Epyx's Jumpman spinoff tasks you with defusing bombs on a series of single-screen girder constructions while enemies pursue and the clock counts down. The ColecoVision port is clean and fast, and the puzzle-platformer hybrid design feels fresher than most arcade games of the era. Mostly forgotten in favour of the original Jumpman but excellent in its own right.",
    rating: "13/15",
    ebayLink: "https://www.ebay.com/sch/i.html?_nkw=jumpman+junior+colecovision&mkevt=1&mkcid=1&mkrid=711-53200-19255-0&campid=5339148069&toolid=10001"
  },
  {
    id: 2,
    title: "CHRONO TRIGGER",
    system: "Super Nintendo",
    genre: "RPG",
    vibe: "Essential",
    year: 1995,
    image: "https://images.unsplash.com/photo-1511512578047-dfb367046420?w=400&h=500&fit=crop",
    description: "A timeless RPG masterpiece that takes you on an epic journey through different eras. With its revolutionary battle system, memorable characters, and multiple endings, this game defined what RPGs could be. The sprite work is gorgeous, and Yasunori Mitsuda's soundtrack is legendary.",
    rating: "15/15",
    ebayLink: "https://www.ebay.com/sch/i.html?_nkw=chrono+trigger+snes&mkevt=1&mkcid=1&mkrid=711-53200-19255-0&campid=5339148069&toolid=10001"
  },
  {
    id: 3,
    title: "STREETS OF RAGE 2",
    system: "Sega Genesis",
    genre: "Beat 'em Up",
    vibe: "Arcade Classic",
    year: 1992,
    image: "https://images.unsplash.com/photo-1493711662062-fa541adb3fc8?w=400&h=500&fit=crop",
    description: "The definitive beat 'em up of the 16-bit era. Punch, kick, and throw your way through city streets with incredibly smooth animations and a pumping Yuzo Koshiro soundtrack. Four playable characters, each with unique movesets, make every playthrough feel different.",
    rating: "14/15",
    ebayLink: "https://www.ebay.com/sch/i.html?_nkw=streets+of+rage+2+genesis&mkevt=1&mkcid=1&mkrid=711-53200-19255-0&campid=5339148069&toolid=10001"
  },
  {
    id: 4,
    title: "TETRIS",
    system: "Game Boy",
    genre: "Puzzle",
    vibe: "Essential",
    year: 1989,
    image: "https://images.unsplash.com/photo-1606144042614-b2417e99c4e3?w=400&h=500&fit=crop",
    description: "The game that sold the Game Boy. Simple, addictive, and perfect for portable play. The Type-A music is burned into the collective consciousness of an entire generation. This version of Tetris is pure, uncluttered brilliance.",
    rating: "15/15",
    ebayLink: "https://www.ebay.com/sch/i.html?_nkw=tetris+game+boy&mkevt=1&mkcid=1&mkrid=711-53200-19255-0&campid=5339148069&toolid=10001"
  },
  {
    id: 5,
    title: "MONKEY ISLAND 2",
    system: "MS-DOS",
    genre: "Adventure",
    vibe: "Classic",
    year: 1991,
    image: "https://images.unsplash.com/photo-1538481199705-c710c4e965fc?w=400&h=500&fit=crop",
    description: "LeChuck's Revenge perfects the SCUMM engine with gorgeous VGA graphics and a twisted Caribbean pirate adventure. The writing is razor-sharp, the puzzles are challenging without being frustrating, and that ending still sparks debates today.",
    rating: "14/15",
    ebayLink: "https://www.ebay.com/sch/i.html?_nkw=monkey+island+2+dos&mkevt=1&mkcid=1&mkrid=711-53200-19255-0&campid=5339148069&toolid=10001"
  },
  {
    id: 6,
    title: "METAL SLUG X",
    system: "Neo Geo",
    genre: "Run and Gun",
    vibe: "Arcade Classic",
    year: 1999,
    image: "https://images.unsplash.com/photo-1580327332978-77bd9f5072ad?w=400&h=500&fit=crop",
    description: "SNK's magnum opus of sprite-based action. Every frame is a work of art, every explosion is perfectly timed, and the difficulty curve will make you feed it more quarters than you'd care to admit. Pure arcade perfection.",
    rating: "15/15",
    ebayLink: "https://www.ebay.com/sch/i.html?_nkw=metal+slug+x+neo+geo&mkevt=1&mkcid=1&mkrid=711-53200-19255-0&campid=5339148069&toolid=10001"
  },
  {
    id: 7,
    title: "CASTLEVANIA: SOTN",
    system: "PlayStation",
    genre: "Metroidvania",
    vibe: "Essential",
    year: 1997,
    image: "https://images.unsplash.com/photo-1606144042614-b2417e99c4e3?w=400&h=500&fit=crop",
    description: "What is a man? A miserable little pile of secrets! Symphony of the Night revolutionized the Castlevania series with its non-linear castle exploration, RPG elements, and gothic atmosphere. The inverted castle twist still amazes.",
    rating: "15/15",
    ebayLink: "https://www.ebay.com/sch/i.html?_nkw=castlevania+symphony+night+playstation&mkevt=1&mkcid=1&mkrid=711-53200-19255-0&campid=5339148069&toolid=10001"
  },
  {
    id: 8,
    title: "GUNSTAR HEROES",
    system: "Sega Genesis",
    genre: "Run and Gun",
    vibe: "Hidden Gem",
    year: 1993,
    image: "https://images.unsplash.com/photo-1511512578047-dfb367046420?w=400&h=500&fit=crop",
    description: "Treasure's debut title is an absolute masterclass in action game design. Combining weapons creates unique attack styles, the bosses are imaginative and challenging, and it pushes the Genesis hardware to its absolute limits.",
    rating: "14/15",
    ebayLink: "https://www.ebay.com/sch/i.html?_nkw=gunstar+heroes+genesis&mkevt=1&mkcid=1&mkrid=711-53200-19255-0&campid=5339148069&toolid=10001"
  },
  {
    id: 9,
    title: "SUPER METROID",
    system: "Super Nintendo",
    genre: "Metroidvania",
    vibe: "Essential",
    year: 1994,
    image: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=400&h=500&fit=crop",
    description: "The pinnacle of 2D game design. Zebes is a masterwork of environmental storytelling, the power-ups feel genuinely empowering, and the atmosphere is unmatched. Every modern Metroidvania owes a debt to this masterpiece.",
    rating: "15/15",
    ebayLink: "https://www.ebay.com/sch/i.html?_nkw=super+metroid+snes&mkevt=1&mkcid=1&mkrid=711-53200-19255-0&campid=5339148069&toolid=10001"
  },
  {
    id: 10,
    title: "EARTHBOUND",
    system: "Super Nintendo",
    genre: "RPG",
    vibe: "Cult Classic",
    year: 1994,
    image: "https://images.unsplash.com/photo-1493711662062-fa541adb3fc8?w=400&h=500&fit=crop",
    description: "Nintendo's weird, wonderful take on the RPG genre. Set in a quirky version of America with psychic kids fighting aliens, this game is bursting with personality. The rolling HP system and modern setting were revolutionary.",
    rating: "14/15",
    ebayLink: "https://www.ebay.com/sch/i.html?_nkw=earthbound+snes&mkevt=1&mkcid=1&mkrid=711-53200-19255-0&campid=5339148069&toolid=10001"
  }
];

export const systems = [
  "Super Nintendo", "Sega Genesis", "Game Boy", "PlayStation", 
  "Neo Geo AES", "ColecoVision", "MS-DOS", "Atari 2600", 
  "Nintendo 64", "Dreamcast", "Game Boy Advance", "Arcade"
];

export const genres = [
  "Adventure",
  "Arcade",
  "Card & Board Game",
  "Fighting",
  "Hack and slash/Beat 'em up",
  "Indie",
  "MOBA",
  "Music",
  "Pinball",
  "Platform",
  "Point-and-click",
  "Puzzle",
  "Quiz/Trivia",
  "Racing",
  "Real Time Strategy (RTS)",
  "Role-playing (RPG)",
  "Shooter",
  "Simulator",
  "Sport",
  "Strategy",
  "Tactical",
  "Turn-based strategy (TBS)",
  "Visual Novel"
];

export const vibes = [
  "Essential", "Hidden Gem", "Arcade Classic", "Cult Classic",
  "One-More-Go", "Deep Cut", "Party Game", "Relaxing",
  "Challenging", "Story-Driven"
];

export const platformFilters = [
  { id: 'all', label: 'ALL' },
  { id: 'console', label: 'CONSOLE' },
  { id: 'handheld', label: 'HANDHELD' },
  { id: 'computer', label: 'COMPUTER' },
  { id: 'arcade', label: 'ARCADE' },
  { id: 'mobile', label: 'MOBILE' }
];
